import { BaseEntity } from "./BaseEntity";
import { Skill } from "./Skill";

export class SkillCriteria extends BaseEntity {
    public name: string = "";
    public skill?: string | Skill = "";

    constructor(model: Partial<SkillCriteria> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PSkillCriteria = Partial<SkillCriteria>;
